<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar :title="titulo" exibeVoltar="true" historyback="true"/>
        </div>
		<div class="app-centro-sem-rodape">
            <table class="table" cellpadding="4" cellspacing="0" align="center">
                <tr>
                    <th colspan="2" align="center">{{titulo}}<br/>{{ new Date() | moment("DD/MM/YYYY, hh:mm") }}</th>
                </tr>
                <tr>
                    <th align="center" width="50%"><b>Data</b></th>
                    <th align="center" width="50%"><b>Valor</b></th>
                </tr>

                <tbody  v-for="item in tabela" v-bind:key="item.DATA_VCT">
                    <tr>
                        <td align="center">{{ item.DATA_VCT | moment("DD/MM/YYYY") }}</td>
                        <td v-if="tipo == 'A'" align="right">{{ item.SUM_SALDO | toCurrency }}</td>
                        <td v-if="tipo == 'R'" align="right">{{ item.SUM_VALOR | toCurrency }}</td>
                    </tr>
                </tbody>
                <tr>
                    <td align="right"><b>Total:</b></td>
                    <td align="right"><b>{{ total | toCurrency }}</b></td>
                </tr>
            </table>      
        </div>
	</div>

</template>


<script>


import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';


export default {
    name: 'LiquidadoEmAberto',
    props: ['id','tipo'],
    components : {
        TopBar
    },

    data() {
        return {
            mensagem : '',
            titulo : '&nbsp;',
            tabela : {}
        };        
    },

    mounted: function () {
        if(this.tipo=='R'){
            this.titulo = 'Liquidado';
        } else {
            this.titulo = 'Em aberto';
        }


        var credordevedor = JSON.parse(atob(this.id));

        request(this, 'GET',
            'Mobile_GetVlrRecebidoAberto',
            `Devedor_Credor=${credordevedor}&aberto_recebido=${this.tipo}&id_filial=${this.$root.getFilial()}`)
        .then(res => {
            if(res){
                this.tabela = res.Tabela;
            }
        });


    },
    
    computed : {
        total: function() {

            if (this.tabela) {
                if(this.tabela.length){
                    if(this.tipo=='A'){
                        return this.tabela.reduce((sum, item) => sum + item.SUM_SALDO, 0);
                    } else {
                        return this.tabela.reduce((sum, item) => sum + item.SUM_VALOR, 0);
                    }

                } else {
                    return 0;
                }
            } else {
                return 0;                
            }
        }
    }
}
</script>

<style scoped>

    .table{
        border-collapse: collapse;
        width: calc(100% - 20px);
        margin: 20px 10px;    
        border: 1px solid var(--dark-color);    
    }

    td{
        --border-collapse: collapse;
        border: 1px solid var(--dark-color);
    }

    th{
        

        border: 1px solid var(--dark-color);
        background-color: var(--primary-color);
        color: white;

    }

</style>